<template lang="pug">
.v-leasing-form-vehicle-data
	fieldset.field-container--dropdown
		legend.sf-heading-2 Gépjármű adatai
		.form-row
			.form-col
				label(aria-hidden="true") Gépjármű állapota
			.form-col
				VueRadioGroup(v-model="model.vehicleUsed", :is-disabled="model.vehicleSource == VEHICLE_SOURCE.IMPORT", legend="Gépjármű állapota", :isLegendHidden="true", :mobileInline="true", :options="vehicleUsed")
		.form-row
			.form-col
				label(aria-hidden="true") Gépjármű eredete
			.form-col
				VueRadioGroup(v-model="model.vehicleSource", legend="Gépjármű eredete", :isLegendHidden="true", :mobileInline="true", :options="vehicleSource")
					VueTooltip(slot="tooltip-1", placement="bottom")
						p(slot="content") Magyarországi rendszámmal és okmányokkal nem rendelkező használt gépjármű.
		.form-row
			.form-col
				.label-tooltip-wrapper
					label(for="vl-dateOfManufacture") Gyártás időpontja
					VueTooltip(placement="bottom")
						p(slot="content")
							template(v-if="!isVehichleDesignationLorry") A személygépkocsi kora a finanszírozási szerződés megkötésekor legfeljebb 16 év lehet és a futamidő végén a kora nem lépheti túl a 18 évet.
							template(v-else="") A kishaszongépjármű kora a finanszírozási szerződés megkötésekor legfeljebb 14 év lehet és a futamidő végén a kora nem lépheti túl a 15 évet.
							template(v-if="isSzechenyi") #[br] Széchényi Lízing GO! finanszírozás esetén a finanszírozandó eszköz életkora igényléskor nem lehet több, mint 8 év.
			.form-col
				VueMaskedInput#vl-dateOfManufacture(v-model="model.dateOfManufacture", addon="pl. 2020-02", :mask="'####-##'", :max-width="128", :max-length="7", :has-error="$v.model.dateOfManufacture.$dirty && $v.model.dateOfManufacture.$invalid", aria-describedby="vl-dateOfManufacture-err", @blur="$v.model.dateOfManufacture.$touch(); $v.ageOfVehicleEndOfFinancing.$touch()")
				VueErrorMessage#vl-dateOfManufacture-err(v-if="$v.model.dateOfManufacture.$dirty && !$v.model.dateOfManufacture.required", position="bottom") Kérjük, adja meg a gyártás időpontját!
				VueErrorMessage#vl-dateOfManufacture-err(v-if="$v.model.dateOfManufacture.$dirty && $v.model.dateOfManufacture.required && (!$v.model.dateOfManufacture.minLength || !$v.model.dateOfManufacture.isBefore)", position="bottom") Kérjük, ellenőrizze a gyártás időpontot! éééé-hh formában kell megadni.
				VueErrorMessage#vl-dateOfManufacture-err(v-if="$v.model.dateOfManufacture.$dirty && $v.model.dateOfManufacture.minLength && $v.model.dateOfManufacture.isBefore && !$v.model.dateOfManufacture.vehicleAgeNotSupported", position="bottom") Sajnos, a gépjárművet max. {{ vehicleAgeLimit }} éves koráig tudjuk lízingelni.
		.form-row
			.form-col
				label(aria-hidden="true") CASCO biztosítás
			.form-col
				VueRadioGroup(v-model="model.insuranceType", legend="Gépjármű Állapota", :isLegendHidden="true", :mobileInline="true", :options="insuranceType", :is-disabled="isSzechenyi")
					VueTooltip(slot="tooltip-0", placement="bottom")
						p(slot="content") A beépített teljes körű casco biztosítás megkötéséről a Merkantil Bank gondoskodik, ennek díját a lízingdíj már tartalmazza.
					VueTooltip(slot="tooltip-1", placement="bottom")
						p(slot="content") A teljes körű biztosítást Ön is megkötheti, kedvezményezettjeként a Merkantil Bankot kell megjelölni.
					VueTooltip(slot="tooltip-2", placement="bottom")
						p(slot="content") Dönthet úgy is, hogy nem köt biztosítást, ebben az esetben kockázati kamatfelárat számítunk fel, ami emeli a lízingdíjat.
		.dropdown-field.dropdown-field--arrow(v-if="insuranceIncluded")
			svg.dropdown-arrow(width="32", height="16", viewbox="0 0 32 16", fill="none", xmlns="http://www.w3.org/2000/svg", aria-hidden="true")
				path(fill-rule="evenodd", clip-rule="evenodd", d="M13.6286 1.96444C13.8848 0.850958 14.8574 0 16 0C17.1426 0 18.1152 0.85096 18.3714 1.96444C19.3548 6.23822 22.6268 16 32 16H0C9.37315 16 12.6452 6.23822 13.6286 1.96444Z", fill="#EFF2F9")
			.dropdown-field-container
				.form-row(v-if="insuranceOwnContribution")
					.form-col
						label#vl-insuranceOwnContribution-lbl(for="vl-insuranceOwnContribution") Biztosítási önrész
					.form-col
						VueSelect#vl-insuranceOwnContribution(:max-width="224", label-id="vl-insuranceOwnContribution-lbl", v-model="model.insuranceOwnContribution", placeholder="Válassz")
							VueSelectOption(v-for="(item, index) in insuranceOwnContribution", :value="item.key", :text="item.value", :index="index", label-id="label1", :key="item.key")
				.form-row(v-if="vehicleManufacturerToDesignation")
					.form-col
						label#vl-manufacturer-lbl(for="vl-manufacturer") Gyártmány
					.form-col
						VueSelect#vl-manufacturer(:max-width="208", label-id="vl-manufacturer-lbl", v-model="model.manufacturer", placeholder="Válassz", :has-error="$v.model.manufacturer.$dirty && $v.model.manufacturer.$invalid", @input="$v.model.manufacturer.$touch()", aria-describedby="vl-manufacturer-err")
							VueSelectOption(v-for="(item, index) in vehicleManufacturerToDesignation", :value="item.key", :text="item.value", :index="index", label-id="label1", :key="item.key")
						VueErrorMessage#vl-manufacturer-err(v-if="$v.model.manufacturer.$dirty && !$v.model.manufacturer.required", position="bottom") Kérjük, válassza ki a gépjármű gyártmányát!
				.form-row
					.form-col
						.label-tooltip-wrapper
							label(for="vl-performance") Gépjármű teljesítménye
							VueTooltip(placement="bottom")
								p(slot="content") 150 kW teljesítmény fölött az beépített casco biztosítás egyedi árazású, emiatt a biztosítás díja eltérhet a kalkulációtól!
					.form-col
						VueInputWithType#vl-performance(v-model="performance", addon="100 kW = 134 lóerő", :max-width="152", :max-width-select="60", :max-length="4", :has-error="$v.model.performance.$dirty && $v.model.performance.$invalid", :options="[ { key: 'KW', value: 'kW' }, { key: 'LE', value: 'LE' }, ]", @blur="$v.model.performance.$touch()", aria-describedby="vl-performance-err")
						VueErrorMessage#vl-performance-err(v-if="$v.model.performance.$dirty && !$v.model.performance.required", position="bottom") Kérjük, adja meg a gépjármű teljesítményét!
						VueErrorMessage#vl-performance-err(v-if="$v.model.performance.$dirty && $v.model.performance.required && !$v.model.performance.numeric", position="bottom") Kérjük, ellenőrizze a megadott teljesítményt!
				.form-row(v-if="!isEnterprise")
					.form-col
						.label-tooltip-wrapper
							label(for="vl-debtorAge") Igénylő kora
							VueTooltip(placement="bottom")
								p(slot="content") A biztosítás díj függ az igénylő korától.
					.form-col
						VueMaskedInput#vl-debtorAge(v-model="model.debtorAge", mask="###", aria-describedby="vl-debtorAge-err", :max-width="104", :max-length="3", :has-error="$v.model.debtorAge.$dirty && $v.model.debtorAge.$invalid", @blur="$v.model.debtorAge.$touch()")
						VueErrorMessage#vl-debtorAge-err(v-if="$v.model.debtorAge.$dirty && !$v.model.debtorAge.required", position="bottom") Kérjük, adja meg az igénylő korát!
						VueErrorMessage#vl-debtorAge-err(v-if="$v.model.debtorAge.$dirty && $v.model.debtorAge.required && !$v.model.debtorAge.minValue", position="bottom") Lízing szerződést 18 év felettiek köthetnek.
				.form-row
					.form-col
						.label-tooltip-wrapper
							label(for="vl-zipCode") Lakcím/székhely irányítószáma
							VueTooltip#vl-zipCode-tooltip(placement="bottom")
								p(slot="content") A biztosítás díj függ az igénylő lakcímétől, vállalkozások esetén a székhelyének címétől
					.form-col
						VueInput#vl-zipCode(v-model="model.zipCode", aria-describedby="zipCode-err vl-zipCode-tooltip", :max-width="104", :max-length="4", :has-error="$v.model.zipCode.$dirty && $v.model.zipCode.$invalid", @blur="$v.model.zipCode.$touch()")
						VueErrorMessage#vl-zipCode-err(v-if="$v.model.zipCode.$dirty && !$v.model.zipCode.required", position="bottom") Kérjük, adja meg az igénylő irányítószámát!
						VueErrorMessage#vl-debtorAge-err(v-if="$v.model.zipCode.$dirty && $v.model.zipCode.required && !$v.model.zipCode.numeric", position="bottom") Kérjük, ellenőrizze a megadott irányítószámot!
</template>

<script>
import VueRadioGroup from '@ui-common/vue-radio-group';
import VueTooltip from '@ui-common/vue-tooltip';
import VueMaskedInput from '@ui-common/vue-masked-input';
import VueInput from '@ui-common/vue-input';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueErrorMessage from '@ui-common/vue-error-message';
import VueInputWithType from '@ui-common/vue-input-with-type';
import { VEHICLE_SOURCE } from '../../constants';
import moment from 'moment';
const HPINKW = 0.735;
const NEW_VALUE = 'N';
const hpToKw = hp => hp * HPINKW;
export default {
	inject: ['$v'],
	data: () => ({
		performance: { type: null, value: null }
	}),
	props: {
		isEnterprise: {
			required: true
		},
		model: {
			required: true
		},
		vehicleUsed: {
			type: Array,
			required: true
		},
		vehicleSource: {
			type: Array,
			required: true
		},
		insuranceType: {
			type: Array,
			required: true
		},
		vehicleManufacturerToDesignation: {
			required: true
		},
		insuranceOwnContribution: {
			type: Array,
			required: true
		},
		isVehichleDesignationLorry: {
			type: Boolean
		},
		vehicleAgeLimit: {
			type: Number
		},
		insuranceIncluded: {
			type: Boolean
		},
		financeTypes: {
			required: true
		}
	},
	components: {
		VueRadioGroup,
		VueTooltip,
		VueMaskedInput,
		VueSelect,
		VueSelectOption,
		VueInput,
		VueErrorMessage,
		VueInputWithType
	},
	watch: {
		isEnterprise(val) {
			if (val) {
				this.model.debtorAge = null;
			}
		},
		performance: {
			handler(val) {
				if ((val.value ^ 0) === val.value) {
					this.model.performance = val.type == 'LE' ? hpToKw(value) : value;
				} else {
					this.model.performance = val.value;
				}
			},
			deep: true
		},
		'model.vehicleSource': {
			handler(val) {
				this.resetValues();
			},
			immediate: true
		},
		'model.vehicleUsed': {
			handler(val) {
				this.resetValues();
				if (val == NEW_VALUE) {
					this.model.dateOfManufacture = moment().format('YYYY-MM');
				}
			},
			immediate: true
		},
		'model.insuranceType': {
			handler(val) {
				this.$v.model.manufacturer.$reset();
				this.$v.model.performance.$reset();
				this.$v.model.debtorAge.$reset();
				this.$v.model.zipCode.$reset();
			},
			immediate: true
		}
	},
	computed: {
		VEHICLE_SOURCE: () => VEHICLE_SOURCE.HOME,
		isSzechenyi() {
			return this.model.financeType === this.financeTypes?.[1]?.key;
		}
	},
	methods: {
		resetValues() {
			if (this.model.vehicleSource == VEHICLE_SOURCE.HOME) {
				if (this.model.vehicleUsed == 'Y') {
					this.model.registrationTax = 0;
				} else {
					this.model.registrationTax = null;
				}
			} else {
				this.model.vehicleUsed = 'Y';
				this.model.registrationTax = null;
			}
			this.model.netSellPrice = null;
			this.model.vat = null;
			this.model.grossSellPrice = null;
			this.model.ownContribution = null;
			this.$v.model.netSellPrice.$reset();
			this.$v.model.vat.$reset();
			this.$v.model.grossSellPrice.$reset();
			this.$v.model.ownContribution.$reset();
			this.$v.model.registrationTax.$reset();
			this.$v.financedPrice.$reset();
		}
	}
};
</script>
<style lang="scss" scoped>
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.dropdown-field--arrow {
	@include media('<tablet') {
		margin-top: 0;
	}
}
</style>
